module.exports = __webpack_public_path__ + "media/images/Logo-Moovejob-fa5c99bcf3bc84970d79c7cfbf082923.png";